export const WAVE_API_URL = 'https://gql.waveapps.com/graphql/public';